export default __webpack_public_path__ + "static/media/puppyBanner.80fcfae7.jpg";